// Patients are stored as a single "First Last" string in patients.name. The CSV
// importer (server/main.py) joins PATFNAME + PATLNAME the same way, so forms and
// bulk uploads produce identical records.

export interface PatientNameParts {
  firstName: string;
  lastName: string;
}

export const joinPatientName = (firstName: string, lastName: string): string =>
  `${firstName.trim()} ${lastName.trim()}`.trim();

export const splitPatientName = (fullName?: string | null): PatientNameParts => {
  const normalized = (fullName || "").replace(/\s+/g, " ").trim();
  if (!normalized) {
    return { firstName: "", lastName: "" };
  }

  // Legacy records typed as "Last, First" by providers before the form was split.
  const commaIndex = normalized.indexOf(",");
  if (commaIndex !== -1) {
    return {
      lastName: normalized.slice(0, commaIndex).trim(),
      firstName: normalized.slice(commaIndex + 1).trim()
    };
  }

  const parts = normalized.split(" ");
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" };
  }

  // The final token is the surname; middle names and initials stay with the
  // first name, which is how "First Last" records were built.
  return {
    firstName: parts.slice(0, -1).join(" "),
    lastName: parts[parts.length - 1]
  };
};
